'use client'

import * as React from 'react'
import { cn } from '../../utils/cn'
import { FadeIn } from '../motion/FadeIn'

interface Logo {
  name: string
  href?: string
  icon?: React.ReactNode
}

interface LogoCloudProps {
  heading?: string
  logos: Logo[]
  grayscale?: boolean
}

export function LogoCloud({
  heading = 'Trusted by industry leaders',
  logos,
  grayscale = true
}: LogoCloudProps) {
  return (
    <section className="py-16 border-y border-[var(--landing-border)]">
      <div className="landing-container">
        <FadeIn>
          <p className="text-sm text-center text-[var(--landing-text-muted)] mb-8">
            {heading}
          </p>
        </FadeIn>

        <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-8">
          {logos.map((logo, index) => (
            <FadeIn key={logo.name} delay={index * 0.05}>
              {logo.href ? (
                <a
                  href={logo.href}
                  className={cn(
                    'block',
                    grayscale && 'logo-grayscale'
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {logo.icon || (
                    <span className="text-[var(--landing-text-muted)] text-lg font-semibold">
                      {logo.name}
                    </span>
                  )}
                </a>
              ) : (
                <div className={cn(grayscale && 'logo-grayscale')}>
                  {logo.icon || (
                    <span className="text-[var(--landing-text-muted)] text-lg font-semibold">
                      {logo.name}
                    </span>
                  )}
                </div>
              )}
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  )
}
